const ClientsSay = () => (
    <section id="clients-say" className="clients-say">
        <div className="container">
            <div className="section-header">
                <h2>what our clients say</h2>
            </div>
            <div className="row">
                <div className="owl-carousel testimonial-carousel">
                    <div className="col-sm-3 col-xs-12">
                        <div className="single-testimonial-box">
                            <div className="testimonial-description">
                                <div className="testimonial-info">
                                    <div className="testimonial-img">
                                        <img src="assets/images/clients/c1.png" alt="A" />
                                    </div>
                                </div>
                                <div className="testimonial-comment">
                                    <p>
                                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis. 
                                    </p>
                                </div>
                                <div className="testimonial-person">
                                    <h2><a href="#a">tomas lili</a></h2>
                                    <h4>new york</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className="single-testimonial-box">
                            <div className="testimonial-description">
                                <div className="testimonial-info">
                                    <div className="testimonial-img">
                                        <img src="assets/images/clients/c2.png" alt="B" />
                                    </div>
                                </div>
                                <div className="testimonial-comment">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis.  
                                    </p>
                                </div>
                                <div className="testimonial-person">
                                    <h2><a href="#b">romi rain</a></h2>
                                    <h4>london</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-3 col-xs-12">
                        <div className="single-testimonial-box">
                            <div className="testimonial-description">
                                <div className="testimonial-info">
                                    <div className="testimonial-img">
                                        <img src="assets/images/clients/c3.png" alt="C" />
                                    </div>
                                </div>
                                <div className="testimonial-comment">
                                    <p>
                                        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Proin placerat posuere elit quis lobortis.  
                                    </p>
                                </div>
                                <div className="testimonial-person">
                                    <h2><a href="#c">john doe</a></h2>
                                    <h4>washington</h4>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
);

export default ClientsSay;
